<template>
    <div>
      <!--<div class="title">-->
      <!--<div class="form-name">-->
      <!--{{baseDataInfo.formname}}-->
      <!--</div>-->
      <!--<div class="form-item-name">-->
      <!--{{baseDataInfo.formitemname}}-->
      <!--</div>-->
      <!--</div>-->
      <a-radio-group style="margin-left: 40px" v-model="chartsType" size="small">
        <a-radio-button value="1">
          柱状图
        </a-radio-button>
        <a-radio-button value="2">
          堆积面积图
        </a-radio-button>
      </a-radio-group>
      <charts-type1 class="main" v-if="chartsType==='1'"  :xData="xData" :xIdData="xIdData" :xValueData="xValueData" :xLabelData="xLabelData" />
      <charts-type2 class="main" v-if="chartsType==='2'"  :xData="xData" :xIdData="xIdData" :xValueData="xValueData" :xLabelData="xLabelData" />
    </div>
</template>

<script>
  import ChartsType1 from './ChartsType1'
  import ChartsType2 from './ChartsType2'
  export default {
    name: 'Charts',
    components: { ChartsType2, ChartsType1 },
    props:{
      periodItemList:{
        type:Array,
        default:()=>{
          return []
        }
      },
      baseDataList:{
        type:Array,
        default:()=>{
          return []
        }
      },

    },
    data(){
      return {
        chartsType:'1',
        xData:[],
        xIdData:[],
        xValueData:[],
        xLabelData:[],
      }
    },
    watch:{
      periodItemList(){
        // this.init()
      }
    },
    computed:{
      baseDataInfo(){
        if(this.baseDataList.length===0){
          return {}
        }
        return  this.baseDataList[0]
      }
    },
    mounted(){
      this.init()
    },
    methods:{
      init(){
        this.initXData()
        this.initData()
      },

      initData(){

        const xLabelData = []
        const xValueData = []
        this.baseDataList.forEach((item,index)=>{
          xLabelData.push('提交人数')
          xLabelData.push(item.result||'-')
        })
        this.xLabelData = xLabelData
        const dataTemp = {}
        this.baseDataList.forEach((item,index)=>{
          item.periodInfoList.forEach((pi,i)=>{
            dataTemp[pi.perioditemid] = dataTemp[pi.perioditemid] || []
            if(index===0){
              dataTemp[pi.perioditemid].push({
                name:'总数',
                resultName:item.result,
                resultId:item.resultid+'_',
                count:pi.formcount || 0
              })
            }
            dataTemp[pi.perioditemid].push({
              name:pi.name,
              resultName:item.result,
              resultId:item.resultid,
              count:pi.submitcount ||0
            })
          })
        })
        const data = {

        }
        const dataIndex = []
        // 初始化一下datakey
        for (let key in dataTemp){
          dataTemp[key].forEach(item=>{
            if(dataIndex.indexOf(item.resultId)<0){
              dataIndex.push(item.resultId)
              data[item.resultId] = data[item.resultId] || []
            }
          })
        }
        this.xIdData.forEach((id,idIndex)=>{
          const dataItem = dataTemp[id]
          if(dataItem==null){
            for (let itemKey in data){
              data[itemKey] = data[itemKey] || []
              data[itemKey].push(0)
            }
          }else{
            dataItem.forEach(item=>{
              data[item.resultId] = data[item.resultId] || []
              data[item.resultId].push(item.count)
            })
          }
        })
        const dataMain = []
        dataIndex.forEach(resultId=>{
          dataMain.push(data[resultId] ||[])
        })
        this.baseDataList.forEach((item,index)=>{
          if(index===0){
            xValueData.push({
              text:'总人数',
              value:dataMain[0],
            })
          }

          xValueData.push({
            text:item.result,
            value:dataMain[index+1]
          })
        })
        this.xValueData = xValueData
      },
      initXData(){
        const xData = []
        const xIdData =[]
        const xValueData = []
        this.periodItemList.forEach(item=>{
          xData.push(item.name)
          xIdData.push(item.id)
          xValueData.push([])
        })
        this.xData = xData
        this.xIdData = xIdData
        this.xValueData = xValueData
      }
    }

  }
</script>

<style scoped lang="less">
  .main{
    height: 500px;
    margin-top: 20px;
    width: calc(100% - 50px);
  }
</style>